import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';
import axios from 'axios';
import {clrwidgate,insertpost,getcolval,getcolnotval,loadwidgate,gets} from './userdefaultdata';
import {isnumber} from './validation';
import {checauthu,getanroidpin,connect} from './Androidconnet';
import {chkwbauthu,getwebpin,connectweb} from './Webconnet';
import { getmessage } from './Dynamictable';

export default class Pinentry extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "";
	
  	}
	
    state = {

	
        name: "",
       respdata: null,   
       url: "",
         p1: "",
         p2: "",
         p3: "",
         p4: "",

    };
    pinbox(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
         let val = event.target.value;
         if(!isnumber(elvalue)){
	  event.target.value = "";
          return;
	}
	if(elvalue.length > 1){
          event.target.value = elvalue.substring(0,1);
           val = elvalue.substring(0,1);
        }
        if(id == 'txtpin1'){
        
	 this.setState({ p1: val });
	}
	else if(id == 'txtpin2'){
	 this.setState({ p2: val });
	}
	else if(id == 'txtpin3'){
	 this.setState({ p3: val });
	}
	else if(id == 'txtpin4'){
	 this.setState({ p4: val });
	}
	
   }

    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
       
	
    }
 forgotpin(e:any){
	
	loadwidgate('container',6);

	e.preventDefault()

    }
  checkmailpin(e:any){
        
        const cpin1 = document.getElementById('txtpin1') as HTMLInputElement;
        const cpin2 = document.getElementById('txtpin2') as HTMLInputElement;
        const cpin3 = document.getElementById('txtpin3') as HTMLInputElement;
        const cpin4 = document.getElementById('txtpin4') as HTMLInputElement;
        
        const pin1 = cpin1.value;
        const pin2 = cpin2.value;
        const pin3 = cpin3.value;
        const pin4 = cpin4.value;
        const pn = pin1.trim() + pin2.trim() + pin3.trim() + pin4.trim();
        if(pn.length > 0){
         
	  const pin = parseInt(pn);
          const hpin = getwebpin();
	 
          if(pin == hpin){
		if(chkwbauthu())
		 connectweb();
                else
                getmessage('Something went wrong','');
                
          }
	  else{
		 getmessage('Invalid pin','');

	 }
	}
               
	e.preventDefault()

    }



 render() {
   
     return (

        
	
<div style={{backgroundColor:'transparent'}} className="pinsetwithmail" id="pinmailcheckdivch">
               
 <div id="upinmaildiv" className="mailpinchk">
                 <div id="mailpindiv"  style={{height:'auto'}} className="per100">
               	  <span className="unamepin"> Enter pin </span> <span className="unamepin">{this.state.name}</span>
		 </div>
 <div className="per100">
              
    <div style={{backgroundColor:'#ad9d4d'}} className="postingrowdiv">
	<div className="txtandpinbox">
	<input type="text" style={{textAlign:'center'}} onChange={e=> this.pinbox(e)} id="txtpin1" className="postingtxtbox" />
                 </div>
	<div className="txtandpinbox">
	<input type="text" style={{textAlign:'center'}} onChange={e=> this.pinbox(e)} id="txtpin2" className="postingtxtbox" />
                 </div>
	<div className="txtandpinbox">
	<input type="text"  style={{textAlign:'center'}} onChange={e=> this.pinbox(e)} id="txtpin3" className="postingtxtbox" />
                 </div>
	<div className="txtandpinbox">
	<input type="text" style={{textAlign:'center'}} onChange={e=> this.pinbox(e)} id="txtpin4" className="postingtxtbox" />
                 </div>
    </div>

 </div>
 <div className="per100">
			
	 <a href="#" className="blanka"  onClick={e=>this.forgotpin(e)}>
		<span style={{width:'25%',marginLeft:'12%'}} className="pinernter">Forgot Pin</span>
	</a>
        <a href="#" className="blanka"  onClick={e=>this.checkmailpin(e)}>
		<span  style={{width:'25%',float:'left',marginLeft:'2%'}} className="pinernter">Start</span>
	</a>
  </div>

 </div>
</div>

   
      );
}
}

